<template>
  <div class="two-bottom-btn">
    <van-button type="default" style="height: 40px; flex: 1; line-height: 40px" @click="cancelClick" round>{{leftText}}</van-button>
    <van-button type="info" style="height: 40px; margin-left: 50px; flex: 1; line-height: 40px" @click="clickBtn" round :loading="loading"  :loading-text="loadingText" >{{rightText}}</van-button>
  </div>
</template>
<script>
  export default {
    props: {
      leftText: {
        type:String,
        default: '取消'
      },
      rightText:{
        type:String,
        default: '确认',
      },
      loading: {
        type:Boolean,
        default: false
      },
      loadingText:{
        type:String,
        default: '加载中',
      }
    },
    name: 'TwoBottomBtn',
    data() {
      return {
      }
    },

    methods: {
      cancelClick() {
        this.$emit('cancelClick')
      },
      clickBtn() {
        this.$emit('confirmClick')
      }
    }
  }
</script>
<style scoped lang="less">
  .two-bottom-btn {
    height: 110px;
    line-height: 110px;
    background: #000;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 21px 0px rgba(186,186,186,0.44);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 100px;
    display: flex;
    align-items: center;
  }
</style>
